(function () {
    'use strict';
    var controllerId = 'segnalazioneAdd';
    angular.module('intro-app').controller(controllerId, ['$scope', 'common', 'vcRecaptchaService', '$uibModalInstance', 'datacontext', '$translate', segnalazioneAddFn]);

    function segnalazioneAddFn($scope, common, vcRecaptchaService, $uibModalInstance, datacontext, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        $scope.segnalazione = {};
        $scope.segnalazione.Id = 0;
        $scope.item = {};
        $scope.item.unita = getListUnitaOrganizzative();
        $scope.item.key = "6LexXAosAAAAAGx66uZ8IJC37jsnzXWCeF1U3pTd";
        $scope.item.loading = false;
        $scope.item.lingua = $translate.use();

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.ok = function (isValid) {
            if (isValid) {
                if (vcRecaptchaService.getResponse() === "") { //if string is empty
                    logError($translate.instant('RisolviRecaptcha'));
                } else {
                    $scope.segnalazione.Recaptcha = vcRecaptchaService.getResponse();
                    addItem($scope.segnalazione).then(function (result) {
                        $scope.segnalazione = result;
                    });
                }
            }
        };

        function getListUnitaOrganizzative() {
            return datacontext.unitaOrganizzativa_getAllList().then(function (data) {
                return $scope.item.unita = data;
            });
        }

        function addItem(item) {
            $scope.item.loading = true;

            return datacontext.segnalazione_add(item).then(function (data) {
                $scope.item.loading = false;

                if (!data) {
                    return logError($translate.instant('ErroreInserimento'));
                }

                logSuccess($translate.instant('SegnalazioneAggiunta'));
                return data;
            });
        }
    }
})();